
import {Component, Vue, Watch} from 'vue-property-decorator';
import stores from '../../stores';
import axiosInstance from '../../helpers/axios';
import CreateFolder from '@/modules/Media/CreateFolder.vue';
import EditFolder from '@/modules/Media/EditFolder.vue';
import NevronHeader from '@/components/NevronHeader.vue';
import NevronSearch from '@/components/NevronSearch.vue';
import NevronEmpty from '@/components/NevronEmpty.vue';
import NevronSearchNoResults from '@/components/NevronSearchNoResults.vue';
import Skeleton from '@/modules/Skeleton.vue';
import {showToaster} from '@/components/DashboardComposer/helpers';
import {translate} from '@/helpers/functions';
import NevronFileDrop from "@/components/NevronFileDrop.vue";
import draggable from 'vuedraggable';


@Component({
  components: {
    NevronFileDrop,
    NevronHeader,
    NevronSearch,
    Skeleton,
    CreateFolder,
    EditFolder,
    NevronEmpty,
    NevronSearchNoResults,
    draggable,
  },
})

export default class MediaList extends Vue {

  openedItem: any = null;
  pathItems: any = null;
  allChecked: boolean = false;
  selectedFiles: number[] = [];
  selectedFolders: number[] = [];
  draggingElement: IMediaItem | null = null;
  rootId: number = 0;

  search: any = {
    query: '',
    current: '',
  };
   isImageFile(fileExtension: any) {
    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'eps', 'bmp', 'tiff', 'tif', 'svg', 'raw'];
    return imageExtensions.includes(fileExtension);
  };
  isVideoFile(fileExtension: any) {
    const videoExtensions = ['mp4', 'mov', 'avi', 'wmv', 'webm', 'mkv', 'mpeg-4', 'ogg'];
    return videoExtensions.includes(fileExtension);
  };
  videoType(type: any) {
    if(type === 'mov') return 'video/mp4';
    return 'video/' + type;
  };

  editFolder(folder: any) {
    // @ts-ignore
    return stores.Folder.editFolder(folder)
      .then((response: any) => {
        this.openedItem = response;
        // @ts-ignore
        this.$refs.edit.$children[0].close();
        this.getSubItems();
      })
      .catch((error: any) => {
        console.log(error);
      });
  }

  forward(fileID: number, e: any) {
    e.preventDefault();
    this.$router.push({name: 'media.folder', params: {folderId: String(fileID)}});
  }

  openItem(isFile: any, id: number) {
    if (isFile) {
      this.$router.push({name: 'media.file.show', params: {fileId: String(id)}});
    } else {
      this.$router.push({name: 'media.folder', params: {folderId: String(id)}});
    }
  }

  back(e: any = null) {
    if (e) {
      e.preventDefault();
    }
    this.$router.push({
      name: 'media.folder',
      params: {folderId: String(this.openedItem.mediaFolderId)},
    });
  }

  goRoot(e: any = null) {
    if (this.openedItem.id !== 0) {
      if (e) {
        e.preventDefault();
      }
      this.$router.push({name: 'media.folder', params: {folderId: String(0)}});
      this.getSubItems();
    }

  }

  @Watch('$route.params.folderId')
  getSubItems() {
    return stores.Folder.getFolder(Number(this.$route.params.folderId), this.search.query)
      .then((response: any) => {
        if (response.mediaFolderId === '') {
          this.rootId = response.id;
        }
        if (response.mediaFolderId === this.rootId) {
          response.mediaFolderId = 0;
        }
        this.openedItem = response;
        this.openedItem.children = this.openedItem.folders.concat(this.openedItem.files);
        Vue.prototype.WebsiteTitle.setTranslatedPageName(this.openedItem.name);
      })
      .catch((error: any) => {
        console.log(error);
      });
  }

  /**
   * Called when changes need to re-render
   */
  mounted() {
    this.getSubItems();
    window.onpopstate = () => this.getSubItems();
    Vue.prototype.WebsiteTitle.setModuleName('media-library');
  }

  openFolder(id: any) {
    this.$router.push({name: 'media.folder', params: {folderId: id}});
  }

  beforeDestroy() {
    window.onpopstate = () => {
      return true;
    };
  }

  @Watch('openedItem')
  setBreadcrumb() {
    const path = this.openedItem.path;
    const pathArray = path.split('/');
    this.pathItems = pathArray.filter(Boolean);
  }

  json(value: any) {
    return JSON.stringify(value, null, 2);
  }

  checkAll() {
    if (!this.allChecked) {
      this.selectedFiles = [];
      this.selectedFolders = [];
      for (const iterator of this.openedItem.files) {
        if (iterator.id) {
          this.selectedFiles.push(iterator.id);
        }
      }
      for (const iterator2 of this.openedItem.folders) {
        if (iterator2.id) {
          this.selectedFolders.push(iterator2.id);
        }
      }
      this.allChecked = true;
    } else {
      this.selectedFiles = [];
      this.selectedFolders = [];
      this.allChecked = false;
    }
  }

  updateCheck() {
    if (this.selectedLength === this.openedItem.children.length && this.selectedLength > 0) {
      this.allChecked = true;
    } else {
      this.allChecked = false;
    }
  }

  @Watch('$route')
  resetCheck() {
    this.selectedFiles = [];
    this.selectedFolders = [];
    this.allChecked = false;
  }

  deleteSelected() {
    const removeFiles = this.selectedFiles.length > 0;
    const removeFolders = this.selectedFolders.length > 0;
    if (removeFiles) {
      stores.File.deleteFiles(this.selectedFiles)
        .then((response: any) => {
          if (!response.success && response.responseCode !== 200) {
            showToaster('danger', '', translate(response.error.message), response.responseCode);
          } else {
            showToaster('success', translate('successfully-deleted'), '');
          }
          if (!removeFolders) {
            this.resetCheck();
            this.getSubItems();
          }
        });
    }
    if (removeFolders) {
      stores.Folder.deleteFolders(this.selectedFolders)
        .then((response: any) => {
          this.resetCheck();
          this.getSubItems();
        })
        .catch((error: any) => {
          console.log(error);
        });
    }
  }

  fileUploaded(file: File, hasMore: boolean) {
    if (!hasMore) {
      this.getSubItems();
    }
  }

  allowDrop(event: DragEvent) {
    event.preventDefault();
  }
  handleDragStart(event: any) {
    const index = event.oldDraggableIndex;
    this.draggingElement = this.openedItem.children[index];
  }
  handleDrop(mediaFolderId: number, event: Event) {
    event.preventDefault();
    if (!this.draggingElement || !this.draggingElement.id) {
      return;
    }
    if (this.draggingElement.id === mediaFolderId) {
      return;
    }
    const files = [...this.selectedFiles];
    const folders = [...this.selectedFolders];
    if (this.draggingElement.fileName) {
      files.push(this.draggingElement.id);
    } else {
      folders.push(this.draggingElement.id);
    }
    stores.Folder.moveMediaItems(mediaFolderId, folders, files)
      .then(() => {
        this.getSubItems();
        this.resetCheck();
        showToaster('success', translate('successfully-updated'), '');
      });

  }

  get selectedLength() {
    return this.selectedFiles.length + this.selectedFolders.length;
  }
}
